export default __webpack_public_path__ + "static/media/work3.8ca17c0f.png";